import { UNSAVED_CHANGES_ACTIVE } from "../constants";

export const setActiveUnsavedChanges = (activeUnsavedChanges: boolean) => {
  sessionStorage.setItem(UNSAVED_CHANGES_ACTIVE, String(activeUnsavedChanges));
};

export const getActiveUnsavedChanges = () => {
  return sessionStorage.getItem(UNSAVED_CHANGES_ACTIVE);
};
